import { notification } from "antd";
import { useEffect } from "react";
import useSWR from "swr";
import { useLanguage } from "~/hooks/useLanguage";
import { getWindowEnv } from "~/helpers/envConfig";
import { getAzureSSOSettings } from "../services/getAzureSSOSettings";

const { DIGITAL_OPERATION_URL } = getWindowEnv();

const fetcher = async () => {
  const response = await getAzureSSOSettings();

  return response;
};

export const useGetAzureSSOSettings = () => {
  const swrKey = createSWRKey();
  const { formatMessage } = useLanguage();
  const { data, isValidating, error } = useSWR(swrKey, fetcher, {
    revalidateOnFocus: false,
    loadingTimeout: 3000,
  });

  if (data) {
    //INFO: Fatih, dvm-test and copilot using same sso settings
    //      so we need to change the redirect uri for copilot
    data.redirectUri = `https://copilot-${DIGITAL_OPERATION_URL}/login`;
  }

  useEffect(() => {
    if (error)
      notification.error({
        message: formatMessage("SomethingWentWrong"),
      });
  }, [error, formatMessage]);

  return {
    ssoData: data,
    getSsoDataLoading: isValidating,
  };
};

const createSWRKey = () => {
  return ["use-get-sso-data"];
};
